import axios from 'axios';
import useOnlineStatus from '../customHook/useOnlineStatus';
//const API_URL = 'http://10.63.0.152:8080/api';
export const instanceAxios = axios.create({ baseURL: window.Configs.URLSERVER })


instanceAxios.interceptors.response.use(function (response) {
  if(response){

  }
  //saveStore(response);
  return response;
}, function (error) {
  console.log(error);
  return Promise.reject(error);
});



const saveStore = (response) => {
  if(!localStorage.getItem('store')){
    localStorage.setItem('store', '[]');
  }
  var _data = JSON.parse(localStorage.getItem('store'));
  
  let exist = _data.find(x=> x.identifier == response.config.url +'|'+ response.config.method  +'|'+ response.config.data);

  if(!exist){
    _data.push({ 
      identifier: response.config.url +'|'+ response.config.method  +'|'+ response.config.data,
      url:  response.config.url,
      body: response.config.data,
      data: response,
      method: response.config.method
    });
    localStorage.setItem('store', JSON.stringify(_data));
  }else{

    _data = _data.filter(x=> x.identifier !== exist.identifier);
    _data.push({ 
      identifier: response.config.url  +'|'+ response.config.method  +'|'+  response.config.data,
      url:  response.config.url,
      body: response.config.data,
      data: response,
      method: response.config.method
    });
    localStorage.setItem('store', JSON.stringify(_data));

  }
}